module.exports = __webpack_public_path__ + "components/flag/static/square/nz-d6ab98cf3bedb7cd0e5b87953d814679.svg";